export const MetalPanel = ({ src, alt, className = "", sheen = true, testId }) => (
  <div
    data-testid={testId}
    data-cursor="panel"
    className={`relative aspect-[4/5] select-none ${className}`}
    style={{ transformStyle: "preserve-3d" }}
  >
    <div
      className="absolute inset-0 p-[3px]"
      style={{
        background: "linear-gradient(180deg, #b9b9bf 0%, #4a4a50 18%, #26262b 50%, #55555b 82%, #a7a7ad 100%)",
        boxShadow: "0 30px 60px -18px rgba(0,0,0,0.85), 0 0 0 1px rgba(255,255,255,0.05)",
      }}
    >
      <div className="relative w-full h-full overflow-hidden bg-[#0a0a0a]">
        <img src={src} alt={alt} loading="lazy" draggable="false" className="w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ boxShadow: "inset 0 0 40px rgba(0,0,0,0.45)" }} />
        {sheen && (
          <div
            className="absolute inset-0 mm-sheen"
            style={{
              background:
                "linear-gradient(115deg, transparent 30%, rgba(255,255,255,0.14) 46%, rgba(255,255,255,0.03) 54%, transparent 70%)",
            }}
          />
        )}
      </div>
    </div>
  </div>
);
